import React, { useState, useEffect } from "react"
import { Link } from "gatsby"

import { Navbar, Nav } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendar, faCameraRetro, faFileImage, faFilm, faIdCardAlt, faMicrophone, faPhone, faMusic } from "@fortawesome/free-solid-svg-icons"
import { faFacebookSquare, faInstagramSquare } from "@fortawesome/free-brands-svg-icons"

const CustomNavbar = ({ siteTitle }) => {
  const pathName = typeof window !== 'undefined' ? window.location.pathname : '';

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 80); // soglia regolabile
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Navbar variant="dark" 
        expand="lg" 
        id="site-navbar"
        className={`custom-navbar ${scrolled ? "navbar-scrolled" : ""}`}
      >
        {/* <Container> */}
        <Link to="/" className="link-no-style">
          <Navbar.Brand as="span">
            <FontAwesomeIcon icon={faCameraRetro} className="mr-1" width="16" />
            {siteTitle}
          </Navbar.Brand>
        </Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto" activeKey={pathName}>
            {/* <a href="https://instagram.com/zannafede/" className="link-no-style" target="_blank" rel="noreferrer">
              <Nav.Link as="span" >
                <FontAwesomeIcon icon={faInstagramSquare} className="mr-1" width="16"  />
                Instagram
              </Nav.Link>
            </a>
            */}
            {/* <a href="https://facebook.com/ZannaFede" className="link-no-style" target="_blank" rel="noreferrer">
              <Nav.Link as="span">
                <FontAwesomeIcon icon={faFacebookSquare} className="mr-1" width="16" />
                Facebook
              </Nav.Link>
            </a> */}
            <Link to="/videoclip-musicali" className="link-no-style">
              <Nav.Link as="span" eventKey="/videoclip-musicali">
                <FontAwesomeIcon icon={faMusic} className="mr-1" width="16" />
                Videoclip
              </Nav.Link>
            </Link>
            <Link to="/filmografia" className="link-no-style">
              <Nav.Link as="span" eventKey="/filmografia">
                <FontAwesomeIcon icon={faFilm} className="mr-1" width="16" />
                filmografia
              </Nav.Link>
            </Link>
            <Link to="/streaming" className="link-no-style">
              <Nav.Link as="span" eventKey="/streaming">
                <FontAwesomeIcon icon={faFilm} className="mr-1" width="16" />
                streaming
              </Nav.Link>
            </Link>
            <Link to="/audio" className="link-no-style">
              <Nav.Link as="span" eventKey="/audio">
                <FontAwesomeIcon icon={faMicrophone} className="mr-1" width="16" />
                Audio
              </Nav.Link>
            </Link>
            <Link to="/portfolio-fotografico" className="link-no-style">
              <Nav.Link as="span" eventKey="/portfolio-fotografico">
                <FontAwesomeIcon icon={faFileImage} className="mr-1" width="16" />
                Fotografia
              </Nav.Link>
            </Link>
            {/*<Link to="/curriculum-biografia" className="link-no-style">
              <Nav.Link as="span" eventKey="/curriculum-biografia">
                <FontAwesomeIcon icon={faIdCardAlt} className="mr-1" width="16" />
                CV - Art
              </Nav.Link>
            </Link>
              */}
            {/*
            <Link to="/eventi" className="link-no-style">
              <Nav.Link as="span" eventKey="/eventi">
                <FontAwesomeIcon icon={faCalendar} className="mr-1" width="16" />
                Eventi
              </Nav.Link>
            </Link>
            */}
            <Link to="/contatti" className="link-no-style">
              <Nav.Link as="span" eventKey="/contatti">
                <FontAwesomeIcon icon={faPhone} className="mr-1" width="16" />
                Contatti
              </Nav.Link>
            </Link>
            {/* <Form inline onSubmit={e => e.preventDefault()}>
              <Form.Group>
                <FormControl
                  type="text"
                  placeholder="Fake Search"
                  className="mr-2"
                />
              </Form.Group>
              <Button>Fake Button</Button>
            </Form> */}
          </Nav>
        </Navbar.Collapse>
        {/* </Container> */}
      </Navbar>
    </>
  )
}

export default CustomNavbar
